(function () {
    'use strict';

    angular
        .module('tswApp')
        .controller('PlansAcquiredController', PlansAcquiredController);

    PlansAcquiredController.$inject = ['TswAppService'];


    function PlansAcquiredController(TswAppService) {
        var vm = this;


        vm.flag                 = false;
        vm.getByFilter          = getByFilter;

        vm.logicOptions = [
            { id: -1, name: 'All' },
            { id: 0, name: 'No' },
            { id: 1, name: 'Yes' }
        ];

        vm.paymentOptions = [
            { id: -1, name: 'All' },
            { id: 0, name: 'Paid' },
            { id: 1, name: 'Not Paid' }
        ];
        
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        vm.dateOfAcquisition = { startDate: null, endDate: null }
        vm.activeSelected = -1
        vm.statusSelected = -1
        vm.scholarshipDiscountSelected = -1

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function activate() {
            // vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function getByFilter () {
            console.log(vm.dateOfAcquisition)
            vm.flag         = false;
            vm.query        = {};
            if (vm.dateOfAcquisition.startDate && vm.dateOfAcquisition.endDate) {
                vm.query['start_date'] = vm.dateOfAcquisition.startDate.format('YYYY-MM-DD');
                vm.query['end_date'] = vm.dateOfAcquisition.endDate.format('YYYY-MM-DD');
            }
            if(vm.activeSelected !== -1) {
                vm.query['active'] = vm.activeSelected;
            }
            if(vm.statusSelected !== -1) {
                vm.query['status'] = vm.statusSelected;
            }
            if(vm.scholarshipDiscountSelected !== -1) {
                vm.query['scholarship_discount'] = vm.scholarshipDiscountSelected;
            }
            
            vm.query['page'] = vm.page;
            TswAppService.getPlansAcquired(vm.query).then(function(response){
                vm.subscriptions    = response.data;
                vm.flag             = true;
                vm.totalItems       = response.total;
                vm.to               = response.to;
                vm.itemsPerPage     = response.per_page;
                vm.setPage(response.current_page);
            }).catch(function(err) {

            });
        }

        activate();
    }

})();